import script from "./studentScanView.vue?vue&type=script&setup=true&lang=js"
export * from "./studentScanView.vue?vue&type=script&setup=true&lang=js"

import "./studentScanView.vue?vue&type=style&index=0&id=7e8bf0c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e8bf0c6"]])

export default __exports__